<template>
  <v-container :class="{ 'in-progress': isOperationInProgress }">
    <div v-if="isOperationInProgress" class="progress-cicular">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-if="!showFinish && !showValidation && !showExamValidation">
      <div
        :is="currentEvaluation.componentName"
        :evaluation="currentEvaluation"
        @evaluateEvent="evaluateEventHandler"
      ></div>
      <v-btn
        class="evaluation-contorl"
        large
        color="primary"
        :disabled="disablePrev"
        @click="prevQuestion"
        >Попереднє питання</v-btn
      >
      <v-btn
        class="evaluation-contorl"
        large
        color="primary"
        :disabled="disableNext"
        @click="nextQuestion"
        >Наступне питання</v-btn
      >
      <v-spacer />
    </div>
    <div class="testAnswer" v-else-if="showFinish">Тест завершено</div>
    <div class="testAnswer" v-else-if="showValidation">
      Тест відправлено на перевірку
    </div>
    <div class="testAnswer" v-else-if="showExamValidation">
      Екзамен відправлен на перевірку
    </div>
    <v-btn
      class="evaluation-contorl"
      v-if="isExam && !showExamValidation"
      large
      color="primary"
      :disabled="disableSend"
      @click="sendEvaluations"
      >Відправити відповіді</v-btn
    >
    <v-snackbar v-model="snackbar">
      {{ toasterText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="closeToaster"
          >Закрити</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';

import QuizEvaluation from '@/components/Base/QuizEvaluation/QuizEvaluation';
import TaskEvaluation from '@/components/Base/TaskEvaluation/TaskEvaluation';
import SelectAnswerEvaluation from '@/components/Base/SelectAnswerEvaluation/SelectAnswerEvaluation';
import AddFileEvaluation from '@/components/Base/AddFileEvaluation/AddFileEvaluation';
export default {
  name: 'EvaluationDeck',
  components: {
    QuizEvaluation,
    TaskEvaluation,
    SelectAnswerEvaluation,
    AddFileEvaluation,
  },
  props: {
    isExam: {
      type: Boolean,
      required: false,
      default: false,
    },
    evaluationDeck: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      disableNext: false,
      disablePrev: false,
      disableSend: false,
      currentEvaluation: {},
      showFinish: false,
      showValidation: false,
      showExamValidation: false,
      examSent: false,
      snackbar: false,
      toasterTimeout: null,
      toasterText: '',
    };
  },

  created() {
    this.currentEvaluation = this.evaluationDeck.getCurrentEvaluation();
    this.updaButtons();
  },

  computed: {
    isOperationInProgress() {
      return this.$store.getters['CurrentLessonStore/isOperationInProgress'];
    },
  },

  methods: {
    async sendEvaluations() {
      try {
        await this.$store.dispatch('CurrentLessonStore/submitTest', {
          evaluations: this.evaluationDeck.getEvaluations(),
        });
        this.examSent = true;
        this.updaButtons();
      } catch (error) {
        console.error(`Get error on send evaluations error^${error}`);
        this.showTaster(`помилка ${error}`);
      }
    },
    showTaster(message) {
      if (this.toasterTimeout) {
        clearTimeout(this.toasterTimeout);
        this.toasterTimeout = null;
      }
      this.snackbar = true;
      this.toasterText = message;
      this.toasterTimeout = setTimeout(() => {
        this.snackbar = false;
      }, 5000);
    },
    closeToaster() {
      if (this.toasterTimeout) {
        clearTimeout(this.toasterTimeout);
        this.toasterTimeout = null;
      }
      this.snackbar = false;
    },
    async sendEvaluation(evaluation) {
      try {
        const isValidAnswer = await this.$store.dispatch(
          'CurrentLessonStore/submitOneTest',
          {
            evaluation,
          }
        );
        return isValidAnswer;
      } catch (error) {
        console.error(`помилка ${error}`);
        this.showTaster('Помилка при загрузці файлів');
        return null;
      }
    },
    checkFinish() {
      if (!this.currentEvaluation.hasAnswer()) {
        return;
      }
      this.showFinish =
        !this.isExam &&
        !this.$store.getters['CurrentLessonStore/hasValidationQuestions'] &&
        this.evaluationDeck.isLast();
      this.showValidation =
        !this.isExam &&
        this.$store.getters['CurrentLessonStore/hasValidationQuestions'] &&
        this.evaluationDeck.isLast();
      this.showExamValidation =
        this.examSent && this.isExam && this.evaluationDeck.isLast();
    },
    updaButtons(isValidAnswer) {
      this.disableNext =
        !this.currentEvaluation.hasAnswer() ||
        this.evaluationDeck.isLast() ||
        (!isValidAnswer && !this.isExam);

      this.disablePrev = this.evaluationDeck.isFirst();
      this.disableSend =
        !this.evaluationDeck.isLast() || !this.currentEvaluation.hasAnswer();
      this.checkFinish();
    },
    async evaluateEventHandler(payload) {
      const { type, data } = payload;
      this.evaluationDeck.setUserAnswer(data.answer);
      switch (type) {
        case evaluationEventEnum.SEND_ANSWER:
          if (this.isExam) {
            this.updaButtons();
            return;
          }
          const isValidAnswer = await this.sendEvaluation(
            this.currentEvaluation
          );
          if (!isValidAnswer && isValidAnswer !== null) {
            this.showTaster('Неправильна відповідь на питання');
            return;
          } else if (isValidAnswer === null) {
            return;
          }
          this.updaButtons(isValidAnswer);
          return;
        case evaluationEventEnum.SHOW_TOASTER:
          this.showTaster(data.text);
        default:
          break;
      }
    },
    nextQuestion() {
      this.currentEvaluation = this.evaluationDeck.moveNextEvaluation();
      this.updaButtons(true);
    },
    prevQuestion() {
      this.currentEvaluation = this.evaluationDeck.movePrevEvaluation();
      this.updaButtons(true);
    },
  },
};
</script>

<style lang="less" scoped>
.evaluation-contorl {
  margin: 10px;
}

.in-progress {
  opacity: 0.5;
  pointer-events: none;
}

.progress-cicular {
  position: absolute;
  z-index: 10;
  left: 50%;
  padding-top: 100px;
}
</style>
